import { Link } from 'react-router-dom'
import { useFlags } from 'launchdarkly-react-client-sdk'
import { useOktaAuth } from '@okta/okta-react'
import { NavContainer, OtherItems } from './Elements'
import AddTransactionsButton from '../AddTransactionsButton'
import { useAppState } from '../../../Context/AppProvider'
import UserDropdown from './UserDropdown'
import UmcCasOptionsNav from './UmcCasOptionsNav'
import { AuthPermissions } from '../../../Utilities/enum'
import BasicNavItem from './BasicNavItem'
interface Props {
  username?: string
  permissions?: string[]
  isMobile: boolean
  onNavLinkClick: () => void
}

const Nav = ({
  username = 'User',
  permissions = [],
  isMobile,
  onNavLinkClick = () => {},
}: Props) => {
  const { casSection, cmsSection } = useFlags()
  const { oktaAuth, authState } = useOktaAuth()
  const appState = useAppState()

  const login = () => oktaAuth.signInWithRedirect()
  const logout = () => oktaAuth.signOut()

  const shouldShowCustomReports = permissions.includes('tenant:view')
  const shouldShowUserManagementSelection = permissions.includes(
    AuthPermissions.userRead
  )

  return (
    <NavContainer>
      {!appState.tenant.id ? (
        <OtherItems>
          <UserDropdown username={username}>
            <BasicNavItem
              isAuthenticated={!!authState?.isAuthenticated}
              login={login}
              logout={logout}
            />
            {cmsSection && (
              <a href="mailto:enterprisesupport@taxbit.com">Contact Us</a>
            )}
          </UserDropdown>
        </OtherItems>
      ) : (
        <>
          <UmcCasOptionsNav
            isMobile={isMobile}
            onNavLinkClick={onNavLinkClick}
            permissions={permissions}
          />
          <OtherItems>
            {casSection && <AddTransactionsButton />}
            <UserDropdown username={username}>
              <BasicNavItem
                isAuthenticated={!!authState?.isAuthenticated}
                login={login}
                logout={logout}
              />
              {shouldShowUserManagementSelection && (
                <Link to="/user-management">User Management</Link>
              )}
              {shouldShowCustomReports && (
                <Link to="/reports/custom">Custom Reports</Link>
              )}
              {cmsSection && (
                <a href="mailto:enterprisesupport@taxbit.com">Contact Us</a>
              )}
            </UserDropdown>
          </OtherItems>
        </>
      )}
    </NavContainer>
  )
}

export default Nav
